// @generated
// This file was automatically generated and should not be edited.
// Run `dev generate pipeline-frontend` to regenerate.

/* eslint-disable unused-imports/no-unused-imports */

// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {ColumnTypeValidationFlag} from 'data-frames/util/validateColumnType';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {LeafType} from 'data-types/benchling-type-def/BenchlingTypeDef';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {PipelineStepDataKind, PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {PipelineStepShape} from 'pipelines/StepShapeUtils';

export const CONVERT_ASM_TO_CSV_STEP_SHAPES = [
  {
    stepType: PipelineStepType.CONVERT_ASM_TO_CSV,
    isDeprecated: false,
    version: 0,
    inputDataShapes: {
      'Input files': {
        systemName: 'Input files',
        displayName: 'Input files',
        kind: PipelineStepDataKind.FILE,
        isMulti: true,
        isRequired: true
      }
    },
    outputDataShapes: {
      'Output files': {
        systemName: 'Output files',
        displayName: 'Output files',
        kind: PipelineStepDataKind.FILE,
        isMulti: true,
        isRequired: true
      }
    },
    config: {
      transformType: {
        kind: 'enum',
        required: true,
        choices: [
          {
            value: 'ALLOTROPE',
            displayName: 'Allotrope'
          },
          {
            value: 'ANALYTE',
            displayName: 'Analyte'
          },
          {
            value: 'COMPENSATION',
            displayName: 'Compensation'
          },
          {
            value: 'DATACUBE',
            displayName: 'Datacube'
          },
          {
            value: 'FRACTIONS',
            displayName: 'Fractions'
          },
          {
            value: 'GROUP',
            displayName: 'Group'
          },
          {
            value: 'INJECTIONS',
            displayName: 'Injections'
          },
          {
            value: 'LOG',
            displayName: 'Log'
          },
          {
            value: 'MEASUREMENT',
            displayName: 'Measurement'
          },
          {
            value: 'MEASUREMENT_SEPARATE_UNIT_COLUMN',
            displayName: 'Measurement Separate Unit Column'
          },
          {
            value: 'MEASUREMENT_WITH_PEAKS',
            displayName: 'Measurement With Peaks'
          },
          {
            value: 'ORIGINAL',
            displayName: 'Original'
          },
          {
            value: 'PEAKS',
            displayName: 'Peaks'
          },
          {
            value: 'POPULATION',
            displayName: 'Population'
          },
          {
            value: 'REGION',
            displayName: 'Region'
          },
          {
            value: 'REPORT_POINT',
            displayName: 'Report Point'
          },
          {
            value: 'REPORT',
            displayName: 'Report'
          },
          {
            value: 'SAMPLE',
            displayName: 'Sample'
          },
          {
            value: 'SAMPLE_SEPARATE_UNIT_COLUMN',
            displayName: 'Sample Separate Unit Column'
          },
          {
            value: 'MEASUREMENT_LOG',
            displayName: 'Measurement Log'
          },
          {
            value: 'TIMESERIES',
            displayName: 'Timeseries'
          },
          {
            value: 'TIMESERIES_NULL_ERRORS',
            displayName: 'Timeseries Null Errors'
          },
          {
            value: 'TIMESERIES_PATH_GROUPED',
            displayName: 'Timeseries Path Grouped'
          },
          {
            value: 'TIMESERIES_PATH_GROUPED_NULL_ERRORS',
            displayName: 'Timeseries Path Grouped Null Errors'
          },
          {
            value: 'WELL',
            displayName: 'Well'
          }
        ]
      }
    }
  }
] as const satisfies ReadonlyArray<PipelineStepShape>;
